import Joi from 'joi';

import {
  EMessageMatcherButtonTypes,
  MAX_URL_LENGTH,
} from 'src/containers/MessageMatchers/definitions';
import {joiResolver, mixed} from 'src/utils/validator';

import {BUTTON_NAME_MAX_LENGTH, BUTTON_PAYLOAD_MAX_LENGTH} from '../definitions';

const MIN_PHONE_LENGTH = 10;
const MAX_PHONE_LENGTH = 19;
const MAX_BUTTONS_COUNT = 10;
const MAX_BUTTON_TYPE_COUNT: Partial<Record<EMessageMatcherButtonTypes, number>> = {
  [EMessageMatcherButtonTypes.CHAT]: 10,
  [EMessageMatcherButtonTypes.URL]: 2,
  [EMessageMatcherButtonTypes.PHONE]: 1,
};

const validatePhoneNumber = (value: string, helpers: Joi.CustomHelpers) => {
  // проверяем длину без +
  const phoneNumberLength = value.trim().slice(1).length;

  if (phoneNumberLength < MIN_PHONE_LENGTH) {
    return helpers.error('string.min', {limit: MIN_PHONE_LENGTH});
  }

  if (phoneNumberLength > MAX_PHONE_LENGTH) {
    return helpers.error('string.max', {limit: MAX_PHONE_LENGTH});
  }

  return value.trim();
};

const formResolver = joiResolver((joi) =>
  joi.object({
    content: joi.object({
      buttons: joi.array().items(
        joi
          .object({
            buttonType: joi.string().required(),
          })
          .when('.buttonType', {
            switch: [
              {
                is: EMessageMatcherButtonTypes.CHAT,
                then: {
                  text: mixed.noEmoji.max(BUTTON_NAME_MAX_LENGTH).required(),
                  payload: joi.string().max(BUTTON_PAYLOAD_MAX_LENGTH).required(),
                },
              },
              {
                is: EMessageMatcherButtonTypes.URL,
                then: {
                  text: mixed.noEmoji.max(BUTTON_NAME_MAX_LENGTH).required(),
                  url: mixed.url.max(MAX_URL_LENGTH).required(),
                },
              },
              {
                is: EMessageMatcherButtonTypes.PHONE,
                then: {
                  text: mixed.noEmoji.max(BUTTON_NAME_MAX_LENGTH).required(),
                  phone: joi.string().custom(validatePhoneNumber).required(),
                },
              },
            ],
          }),
      ),
    }),
  }),
);

export {
  formResolver,
  validatePhoneNumber,
  MAX_BUTTONS_COUNT,
  MAX_BUTTON_TYPE_COUNT,
  BUTTON_PAYLOAD_MAX_LENGTH,
};
